import { render, staticRenderFns } from "./UploadShipmentDocuments.vue?vue&type=template&id=c9ff71d0&"
import script from "./UploadShipmentDocuments.vue?vue&type=script&lang=js&"
export * from "./UploadShipmentDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports